export default "__VITE_ASSET__BBZhdkBD__"